export enum MmuDeviceProductGroup {
  WM = 'wm', // Washing Machine
  TD = 'td', // Tumble Dryer
  DW = 'dw', // Dishwasher
  WD = 'wd', // Washer-Disinfector
  ST = 'st' // Sterilizer
}
